// extracted by mini-css-extract-plugin
export default {"container":"mdgNA","image":"_6IL8K","desktop":"-g1G-","mobile":"dl0sT","imageFit":"AkIir"};